import { defineStore } from 'pinia'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { ref, reactive } from 'vue'
import PerfectScrollbar from 'perfect-scrollbar';
import Swal from 'sweetalert2'
import { closeModal, openModal, hideModal, centToDollar, formatDate } from '../utilities/_helpers'
import { useUserStore } from './UserStore.js'
import { useSettingStore } from './SettingStore.js'
import { fix } from 'mathjs'
import _ from 'lodash';

export const useMessageStore = defineStore('MessageStore', {
    state: () => {
        return {
            SINGLETYPE: 1,
            MULTITYPE: 2,
            BUSINESS_CLIENT: 3,
            chats: reactive({
                isLoading: false,
                title: null,
                data: []
            }),
            conversations: reactive({
                isLoading: false,
                data: []
            }),
            activeChat: reactive({}),
            route: useRoute(),
            router: useRouter(),
            message: ref(null),
            psChat: ref(null),
            psConversation: ref(null),
            sendButtonKey: ref(1),
            updateMessageModalId: 'compose-message-modal',
            messageModel: 'message-model',
            title: ref(null),
            client: ref(null),
            clients: reactive({}),
            openModal: openModal,
            hideModal: hideModal,
            isSending: ref(false),
            userStore: useUserStore(),
            settingStore: useSettingStore(),
            fix: fix,
            rooms_dded:ref(false),
            subscribedChannels: ref([]),
            rooms:ref([]),
            searchValue:ref(),
            newMessages:ref(false),
            client_rooms_dashboard:ref([])
        }
    },
    actions: {
        fetchChats(url, isSearch = false,client = null,user=null) {
            const $this = this;
            $this.chats.isLoading = true;
            axios.get(url,{params: {
                title: $this.searchValue
            }})
            .then(function (response) {
                if(!_.isNull(client)){
                    if(response.data.data.data.data.length <= 0){
                        $this.startMessaging(client,user,true)
                    }else{
                        $this.activeChat = response.data.data.data.data[0]
                        $this.conversation();
                    }

                    $this.chats.data.push(...response.data.data.data.data);
                    $this.rooms.push(...response.data.data.data.data);
                    $this.updateRooms($this.rooms,$this.userStore.user);
                    $this.chats.next_page_url = response.data.data.data.next_page_url;
                    $this.chats.isLoading = false;
                    return;
                }
                if (isSearch) {
                    $this.chats.data = response.data.data.data.data;
                }
                else {
                    $this.chats.data.push(...response.data.data.data.data);
                    $this.rooms = [];
                    $this.rooms.push(...response.data.data.data.data);

                    $this.updateRooms($this.rooms,$this.userStore.user);
                }
                $this.chats.next_page_url = response.data.data.data.next_page_url;
                $this.chats.isLoading = false;

                if($this.psChat && !_.isNull(client) && (!_.isNull($this.psChat) || !_.isUndefined($this.psChat))){
                    $this.psChat.update();
                }
            });
        },
        conversation(url = null) {
            const $this = this;
            let route;
            if (_.isNull(url)) {
                route = $this.router.resolve(
                    {
                        name: 'conversations',
                        params: {
                            room: $this.activeChat.id
                        }
                    }
                );
                url = route.href;
            }
            $this.conversations.isLoading = true;
            axios.get(url)
            .then(function (response) {
                if ($this.conversations.data.length == 0) {
                    $this.conversations.data = response.data.data;
                    document.getElementById("user-conversation").addEventListener('ps-y-reach-start', function () {
                        if (
                            ($this.conversations.isLoading == false)
                            &&
                            !_.isNull($this.conversations.next_page_url)
                        ) {
                            $this.conversation($this.conversations.next_page_url);
                        }
                    });
                    setTimeout(() => {
                        document.querySelector('.chats .chat:last-child').scrollIntoView();
                    }, 1000);
                }
                else {

                    $this.conversations.data.data.unshift(...response.data.data.data);
                    setTimeout(() => {
                        document.querySelector('.chats .chat:nth-child(9)').scrollIntoView();
                    }, 1000);
                }
                $this.conversations.next_page_url = response.data.data.next_page_url;
                $this.conversations.isLoading = false;
                $this.psConversation.update();
            });
        },
        searchClient(){
            const $this = this;
            const route = $this.router.resolve(
                {
                    name: 'search-client'
                }
            );
            let url = route.href;
            if(!_.isEmpty($this.client)){
                axios.post(url,{searchTerm:$this.client})
                .then(function (response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        $this.clients = [];
                        return;
                    }
                    $this.clients = response.data.data
                });
            }

        },
        updateRead(user){
            // if(this.activeChat.users[0].last_conversation.sender_id == user.id){
            //     return;
            // }
            const route = this.router.resolve(
                {
                    name: 'mark-read',
                    params: {
                        room: this.activeChat.id
                    }
                }
            );
            let url = route.href;
            axios.get(url)
            .then(function (response) {

            });
        },
        markAsRead(message_id){
            setTimeout(() => {
                var divElement = document.querySelectorAll("#mark-as-read-"+message_id);
                divElement.forEach(element => {
                    element.classList.remove("notify-client-in-app");
                });
                this.rooms.forEach(room => {
                    if(this.activeChat.users[0].user_id == room.users[0].user_id){
                        this.activeChat.users[0].unread = 0
                    }
                });
            }, 3000);
        },
        deleteChat(chat) {
            let $this = this;
            let roomDelete;
            Object.assign($this.activeChat, chat);
            const route = $this.router.resolve(
                {
                    name: 'delete-room',
                    params: { room: $this.activeChat.id }
                }
            );
            Swal.fire({
                title: 'Are you sure you want to delete Chat?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    axios.delete(route.href)
                    .then(function(response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        _.remove($this.chats.data, { id: response.data.data.id });
                        $this.activeChat={};
                        toastr.success(response.data.message, 'Success!');
                        return;
                    }).catch(function(error) {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    });
                }
            });
        },
        sendMessage(message) {
            const $this = this;
            let route;
            if(_.includes(['client-message'], this.route.name)){
                route = this.router.resolve(
                    {
                        name: 'user-to-user-send',
                        params: {
                            room: $this.activeChat.id
                        }
                    }
                );
            }else{
                route = $this.router.resolve(
                    {
                        name: 'business-send',
                        params: {
                            room: $this.activeChat.id,
                            client:$this.activeChat.users[0].user_id
                        }
                    }
                )
            }
            setTimeout(() => {
                document.querySelector('.chats .chat:last-child').scrollIntoView();
            }, 1000);
            $this.isSending = true;
            if(_.isEmpty($this.message)){
                toastr.error('Please Type In A Message.', 'Error!');
                return;
            }else{
                axios.post(route.href, { message: $this.message })
                .then(function (response) {
                    $this.isSending = false;
                    $this.sendButtonKey++;
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.message = null;
                    // $this.conversations.data.push(response.data.data.conversation);
                    // if ($this.activeChat.id == true) {
                    //     $this.chats.data.unshift(response.data.data.chat);
                    //     Object.assign($this.activeChat, response.data.data.chat);
                    // }
                    setTimeout(() => {
                        document.querySelector('.chats .chat:last-child').scrollIntoView();
                    }, 1000);
                    // $this.conversation($this.activeChat);
                });
            }
        },
        newConversation() {
            this.activeChat = [];
            this.activeChat.id = true;
            this.activeChat.title = null;
            this.conversations.data = [];
        },
        businessStartMessaging(client,user){
            let route,$this=this;
            this.activeChat = [];
            this.chats.data = [];
            this.conversations.data = [];
            if(!_.isNull(client)){
                route = $this.router.resolve(
                    {
                        name: 'rooms',
                        params:{
                            client : client
                        }
                    }
                );
            }
            if ($this.chats.isLoading == false) {
                $this.fetchChats(route.href,false,client,user);
            }
        },
        startMessaging(id,user,isClient=false){
            const $this = this,
            route = $this.router.resolve(
                {
                    name: 'new-message',
                    params: {
                        client: id
                    }
                }
            );
            axios.get(
                route.href
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                $this.chats.data.push(response.data.data);
                $this.rooms.push(response.data.data);
                Object.assign($this.activeChat, response.data.data);
                $this.conversation()

                $this.pushItemToFirst(response.data.data.id)
                $this.updateRooms($this.rooms,$this.userStore.user);
                if(isClient == false){
                    $('#close_client_model').click();
                }else{
                    $this.activeChat = response.data.data
                    $this.conversation();
                }
                return;
            }).catch(function(error) {
                console.log(error);
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        },
        updateRooms(rooms,user){
            rooms.forEach((room) => {
                if (!this.subscribedChannels.includes(room.id)) {
                    this.addPusherRooms(room,user);
                    this.subscribedChannels.push(room.id); // Add the channel ID to the list of subscribed channels
                }
            });
        },
        checkNewMessage(){
            const $this = this,
            route = $this.router.resolve(
                {
                    name: 'check-new-message',
                }
            );
            axios.get(
                route.href
            ).then(function(response) {
                if(response.data.error == true) {
                    $this.newMessages = false
                    return;
                }
                if(response.data.data > 0){
                    $this.newMessages = true
                }
                return;
            }).catch(function(error) {
                $this.newMessages = false
                console.log(error);

            });
        },
        addPusherRooms(room,user){
            Echo.channel(`room.${room.id}`)
            .listen('.messages', (e) => {
                if (e.response.error === false) {
                    return;
                }
                if(this.activeChat.id == e.response.room_id){
                    if(this.conversations.data.length <= 0){
                        this.conversations.data.data = e.response
                        this.conversations.data.next_page_url = null

                    }else{
                        this.conversations.data.data.push(e.response)
                    }
                    document.getElementById("user-conversation").addEventListener('ps-y-reach-start', function () {
                        if (
                            ($this.conversations.isLoading == false)
                            &&
                            !_.isNull($this.conversations.next_page_url)
                        ) {
                            $this.conversation($this.conversations.next_page_url);
                        }
                    });
                    setTimeout(() => {
                        document.querySelector('.chats .chat:last-child').scrollIntoView();
                    }, 1000);
                }

                this.updateLastConversation(room.id,e.response)
                if(user.id !== e.response.sender_id){
                    this.pushItemToFirst(room.id)
                }
                this.rooms.forEach(room => {
                    if(room.id == e.response.room_id){
                        if(this.activeChat.id !== room.id){
                            room.users[0].unread +=1
                            return;
                        }
                    }
                });
            });

        },
        updateLastConversation(roomId,data){

            const roomToUpdate = this.chats.data.find(item => item.id === roomId);

            if (roomToUpdate) {
                // Use _.get to safely access nested properties
                const lastConversation = _.get(roomToUpdate, 'users[0].last_conversation');

                if (lastConversation) {
                  // If last_conversation exists, update its properties
                  roomToUpdate.users[0].last_conversation.message = data.message;
                  roomToUpdate.users[0].last_conversation.created_at = data.created_at;
                } else {
                  // If last_conversation is null or undefined, create a new object
                  roomToUpdate.users[0].last_conversation = {
                    message: data.message,
                    created_at: data.created_at,
                  };
                }

                if (roomId !== this.activeChat.id) {
                  roomToUpdate.users[0].unread += 1;
                }

                // this.items = [...this.items];
            }
        },
        pushItemToFirst(roomId) {
            // Find the index of the item with the given itemId
            const index = this.chats.data.findIndex(room => room.id === roomId);

            if (index !== -1) {
              const item = this.chats.data.splice(index, 1)[0];
              this.chats.data.unshift(item);
            }
          },
    },
    getters: {
    },
})
